import dayjs from "dayjs";

export const fmtDate = (value) => value && dayjs(value).format("DD.MM.YYYY")

export const strDate2Server = (value) => {
  if (!value) return null;
  return dayjs(value).format("YYYY-MM-DD");
}

export const ftmPrice = value => {
  if (!value) return value;
  const formatted = value.toFixed(2);
  return formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

/** Вид прохода по предварительной записи (RecordPassVid) */
export const RECORD_PASS_VID = { ByAbon: 0, ByPayment: 1, ByPacket: 2 };

export const recordPassVidOptions = [
  { value: RECORD_PASS_VID.ByAbon, label: "при наличии абонемента" },
  { value: RECORD_PASS_VID.ByPayment, label: "за плату" },
  { value: RECORD_PASS_VID.ByPacket, label: "за наличие услуг пакета" },
];